export const TID = {
  nav: {
    root: "site-nav",
    logo: "nav-logo",
    bookBtn: "nav-book-btn",
    portfolioLink: "nav-portfolio-link",
    processLink: "nav-process-link",
    storyLink: "nav-story-link",
    homeownersLink: "nav-homeowners-link",
    buildersLink: "nav-builders-link",
  },
  hero: {
    root: "hero-section",
    headline: "hero-rotating-headline",
    scrollHint: "hero-scroll-hint",
  },
  audiences: {
    root: "audiences-section",
    homeownerCard: "audience-homeowner-card",
    builderCard: "audience-builder-card",
    homeownerCta: "audience-homeowner-cta",
    builderCta: "audience-builder-cta",
  },
  emotional: { root: "emotional-section", outcome: "emotional-outcome" },
  builderConfidence: {
    root: "builder-confidence-section",
    projectType: "builder-project-type",
    pillar: "builder-pillar",
  },
  storytelling: { root: "story-section", step: "story-step" },
  craftsmanship: { root: "craft-section", item: "craft-item" },
  scale: { root: "scale-section", item: "scale-item" },
  social: { root: "social-section", story: "social-story" },
  portfolio: {
    root: "portfolio-section",
    card: "portfolio-card",
    track: "portfolio-track",
    filter: "portfolio-filter",
    filterAll: "portfolio-filter-all",
    filterHome: "portfolio-filter-homeowner",
    filterBuilder: "portfolio-filter-builder",
  },
  value: { root: "value-section", stat: "value-stat", column: "value-column" },
  process: { root: "process-section", step: "process-step" },
  trust: { root: "trust-section", metric: "trust-metric" },
  trade: { root: "trade-section", proof: "trade-proof" },
  cta: {
    root: "cta-section",
    openBtn: "cta-open-btn",
    tradeBtn: "cta-trade-btn",
    form: "cta-form",
    audienceHome: "cta-audience-home",
    audienceBuilder: "cta-audience-builder",
    name: "cta-form-name",
    email: "cta-form-email",
    phone: "cta-form-phone",
    suburb: "cta-form-suburb",
    company: "cta-form-company",
    project: "cta-form-project",
    message: "cta-form-message",
    submit: "cta-form-submit",
    success: "cta-form-success",
    closeBtn: "cta-form-close",
  },
  footer: { root: "site-footer" },
};
